module.exports = __webpack_public_path__ + "img/bz6.2d5c11f2.png";